import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { EObservationStatus } from "../interfaces/IObservation";

type TStatusTextKey = {
    [key in EObservationStatus]: string;
}
export const StatusTextKey: TStatusTextKey = {
    [EObservationStatus.New]: "Uusi",
    [EObservationStatus.InProgress]: "Käsittelyssä",
    [EObservationStatus.Finished]: "Käsitelty",
    [EObservationStatus.Late]: "Myöhässä",
    [EObservationStatus.Unknown]: "Unknown",
};

const getTextProps = (t: TFunction): TStatusTextKey => ({
    [EObservationStatus.New]: t("Uusi"),
    [EObservationStatus.InProgress]: t("Käsittelyssä"),
    [EObservationStatus.Finished]: t("Käsitelty"),
    [EObservationStatus.Late]: t("Myöhässä"),
    [EObservationStatus.Unknown]: t("Unknown"),
})

export const getTranslatedStatusTexts = getTextProps;

export const useTranslatedStatus = (status: EObservationStatus): string => {
    const texts = getTextProps(useTranslation().t);
    return texts[status];
};